import { forwardRef } from 'react';
import Link from 'next/link';
import withLanguageContext from '@/context/consumerHOC/LanguageConsumer';

const CustomLink = forwardRef(function CustomLink(
	{ style, url, className, prefetch = false, scroll = true, replace = false, external = false, target, ariaLabel, children, content, disableCr, onMouseEnter, onMouseLeave, selectedLang },
	ref
) {
	const href =
		typeof url === 'object'
			? { ...url, pathname: external ? url.pathname : selectedLang == 'en' ? url.pathname : `/${selectedLang}${url.pathname}` }
			: external
				? url
				: selectedLang == 'en'
					? url
					: `/${selectedLang}${url}`;

	const label =
		ariaLabel ||
		(typeof url === 'string'
			? url.replaceAll('/', '').includes('https') || url.replaceAll('/', '').includes('http') || url.replaceAll('/', '').includes('mailto') || url.replaceAll('/', '').includes('tel')
				? url
				: url.replaceAll('/', '')
			: '');

	const cls = `link-item ${!disableCr && 'crCircle'} ${className || ''}`;

	//! outside link
	if (external) {
		return (
			<a
				ref={ref}
				href={typeof url === 'string' ? url : url?.pathname || ''}
				className={cls}
				style={style}
				target={target || '_blank'}
				rel='noopener noreferrer'
				aria-label={label}
				onMouseEnter={onMouseEnter || undefined}
				onMouseLeave={onMouseLeave || undefined}>
				{children || content}
			</a>
		);
	}

	//! inner link
	return (
		<Link
			ref={ref}
			href={href}
			className={cls}
			style={style}
			scroll={scroll}
			replace={replace}
			prefetch={prefetch}
			target={target || '_self'}
			aria-label={label}
			onMouseEnter={onMouseEnter || undefined}
			onMouseLeave={onMouseLeave || undefined}>
			{children || content}
		</Link>
	);
});

export default withLanguageContext(CustomLink, ['selectedLang']);
